// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 40px;
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--glass-light-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border-bottom: 1px solid transparent;
  transition: all 0.25s ease;
}

.navbar--scrolled {
  background: rgba(255, 255, 255, 0.78);
  border-bottom: 1px solid var(--glass-light-border);
  box-shadow: var(--shadow-sm);
}

.navbar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 74px;
}

.navbar__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 20px;
  color: var(--text-dark);
}

.navbar__brand-accent {
  color: var(--teal);
}

.navbar__logo {
  width: 38px;
  height: 38px;
  border-radius: 11px;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 198, 167, 0.35);
}

.navbar__links {
  display: flex;
  align-items: center;
  gap: 30px;
}

.navbar__links a {
  position: relative;
  font-size: 14.5px;
  font-weight: 600;
  color: var(--text-dark);
  opacity: 0.8;
  transition: opacity 0.15s ease, color 0.15s ease;
}

.navbar__links a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, var(--teal), var(--amber));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.25s ease;
}

.navbar__links a:hover {
  opacity: 1;
  color: var(--teal-dark);
}

.navbar__links a:hover::after {
  transform: scaleX(1);
}

.navbar__faq-link {
  position: relative;
  font-family: var(--font-body);
  font-size: 14.5px;
  font-weight: 600;
  color: var(--text-dark);
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.15s ease, color 0.15s ease;
}

.navbar__faq-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, var(--teal), var(--amber));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.25s ease;
}

.navbar__faq-link:hover {
  opacity: 1;
  color: var(--teal-dark);
}

.navbar__faq-link:hover::after {
  transform: scaleX(1);
}

.navbar__cta::after {
  display: none;
}

.navbar__cta {
  margin-left: 4px;
}

.navbar__toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  background: transparent;
}

.navbar__toggle span {
  display: block;
  height: 2.5px;
  border-radius: 2px;
  background: var(--text-dark);
  transition: all 0.25s ease;
}

@media (max-width: 900px) {
  .navbar__toggle {
    display: flex;
  }

  .navbar__links {
    position: fixed;
    top: 114px;
    left: 0;
    right: 0;
    background: #fff;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 14px 24px 26px;
    box-shadow: 0 16px 24px rgba(17, 24, 39, 0.08);
    transform: translateY(-140%);
    opacity: 0;
    pointer-events: none;
    transition: all 0.25s ease;
  }

  .navbar__links--open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }

  .navbar__links a,
  .navbar__faq-link {
    width: 100%;
    padding: 12px 0;
    border-bottom: 1px solid var(--border-soft);
    text-align: left;
  }

  .navbar__cta {
    margin-top: 10px;
    margin-left: 0;
    width: 100%;
    justify-content: center;
  }

  .navbar__toggle--open span:nth-child(1) {
    transform: translateY(7.5px) rotate(45deg);
  }
  .navbar__toggle--open span:nth-child(2) {
    opacity: 0;
  }
  .navbar__toggle--open span:nth-child(3) {
    transform: translateY(-7.5px) rotate(-45deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,wCAAwC;EACxC,gDAAgD;EAChD,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;IACV,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,uBAAuB;IACvB,8CAA8C;IAC9C,4BAA4B;IAC5B,UAAU;IACV,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,UAAU;IACV,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,2CAA2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0CAA0C;EAC5C;EACA;IACE,UAAU;EACZ;EACA;IACE,4CAA4C;EAC9C;AACF","sourcesContent":[".navbar {\n  position: fixed;\n  top: 40px;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: var(--glass-light-bg);\n  backdrop-filter: blur(var(--glass-blur));\n  -webkit-backdrop-filter: blur(var(--glass-blur));\n  border-bottom: 1px solid transparent;\n  transition: all 0.25s ease;\n}\n\n.navbar--scrolled {\n  background: rgba(255, 255, 255, 0.78);\n  border-bottom: 1px solid var(--glass-light-border);\n  box-shadow: var(--shadow-sm);\n}\n\n.navbar__inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 74px;\n}\n\n.navbar__brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 20px;\n  color: var(--text-dark);\n}\n\n.navbar__brand-accent {\n  color: var(--teal);\n}\n\n.navbar__logo {\n  width: 38px;\n  height: 38px;\n  border-radius: 11px;\n  object-fit: cover;\n  box-shadow: 0 4px 12px rgba(0, 198, 167, 0.35);\n}\n\n.navbar__links {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n\n.navbar__links a {\n  position: relative;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: var(--text-dark);\n  opacity: 0.8;\n  transition: opacity 0.15s ease, color 0.15s ease;\n}\n\n.navbar__links a::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -4px;\n  width: 100%;\n  height: 2px;\n  border-radius: 2px;\n  background: linear-gradient(90deg, var(--teal), var(--amber));\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.25s ease;\n}\n\n.navbar__links a:hover {\n  opacity: 1;\n  color: var(--teal-dark);\n}\n\n.navbar__links a:hover::after {\n  transform: scaleX(1);\n}\n\n.navbar__faq-link {\n  position: relative;\n  font-family: var(--font-body);\n  font-size: 14.5px;\n  font-weight: 600;\n  color: var(--text-dark);\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity 0.15s ease, color 0.15s ease;\n}\n\n.navbar__faq-link::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -4px;\n  width: 100%;\n  height: 2px;\n  border-radius: 2px;\n  background: linear-gradient(90deg, var(--teal), var(--amber));\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.25s ease;\n}\n\n.navbar__faq-link:hover {\n  opacity: 1;\n  color: var(--teal-dark);\n}\n\n.navbar__faq-link:hover::after {\n  transform: scaleX(1);\n}\n\n.navbar__cta::after {\n  display: none;\n}\n\n.navbar__cta {\n  margin-left: 4px;\n}\n\n.navbar__toggle {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  gap: 5px;\n  width: 40px;\n  height: 40px;\n  background: transparent;\n}\n\n.navbar__toggle span {\n  display: block;\n  height: 2.5px;\n  border-radius: 2px;\n  background: var(--text-dark);\n  transition: all 0.25s ease;\n}\n\n@media (max-width: 900px) {\n  .navbar__toggle {\n    display: flex;\n  }\n\n  .navbar__links {\n    position: fixed;\n    top: 114px;\n    left: 0;\n    right: 0;\n    background: #fff;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    padding: 14px 24px 26px;\n    box-shadow: 0 16px 24px rgba(17, 24, 39, 0.08);\n    transform: translateY(-140%);\n    opacity: 0;\n    pointer-events: none;\n    transition: all 0.25s ease;\n  }\n\n  .navbar__links--open {\n    transform: translateY(0);\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .navbar__links a,\n  .navbar__faq-link {\n    width: 100%;\n    padding: 12px 0;\n    border-bottom: 1px solid var(--border-soft);\n    text-align: left;\n  }\n\n  .navbar__cta {\n    margin-top: 10px;\n    margin-left: 0;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .navbar__toggle--open span:nth-child(1) {\n    transform: translateY(7.5px) rotate(45deg);\n  }\n  .navbar__toggle--open span:nth-child(2) {\n    opacity: 0;\n  }\n  .navbar__toggle--open span:nth-child(3) {\n    transform: translateY(-7.5px) rotate(-45deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
